import assetService from '@/services/asset.js'

const assetHandler = {
  state: {
    profileDetails: {},
    allAssets: [],
    loginLayout: JSON.parse(window.localStorage.ApiculusEnv).pageLayout || 'left',
    freeEmailProviderList: [],
    bannerModes: []
  },

  mutations: {
    MUTATION_PROFILE_DETAILS (state, payload) {
      if (payload) {
        state.profileDetails = payload
      } else {
        state.profileDetails = {}
      }
    },
    MUTATION_GET_ASSETS (state, payload) {
      state.allAssets = payload.result || []
    },
    MUTATION_FREE_EMAIL_LIST (state, payload) {
      state.freeEmailProviderList = payload && Object.keys(payload).length ? payload.domains : []
    },
    MUTATION_GET_MODES (state, payload) {
      state.bannerModes = payload.result || []
    },
  },

  actions: {
    async ACTION_DOWNLOAD_LOGO (context, obj) {
      const res = await assetService.downloadImage(obj)
      return res
    },
    async ACTION_GET_PROFILE_DETAILS (context) {
      let profile = await assetService.adminProfile()
      context.commit('MUTATION_PROFILE_DETAILS', profile)
      return profile
    },
    async ACTION_LIST_ASSET (context, obj) {
      const uploadResponse = await assetService.list(obj)
      context.commit('MUTATION_GET_ASSETS', uploadResponse)
      return uploadResponse
    },
    async ACTION_FETCH_FREE_EMAIL_PROVIDERS (context) {
      let resp = await assetService.getFreeEmailProviders()
      context.commit('MUTATION_FREE_EMAIL_LIST', resp)
      return Promise.resolve()
    },
    async ACTION_FETCH_BANNER_MODES (context) {
      let resp = await assetService.getBannerModes()
      context.commit('MUTATION_GET_MODES', resp)
      return resp
    }
  },
  getters: {
    getprofileDetails: state => state.profileDetails,
    getAllAssets: state => state.allAssets,
    getPageLayout: state => state.loginLayout,
    getFreeEmailProviders: state => state.freeEmailProviderList
  }
}

export default assetHandler
